import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BaseComponent } from "./base.component";
import { VideoDetailComponent } from "./video-detail/video-detail.component";
import { HomeComponent } from "./home/home.component";
import { SearchPageComponent } from "./search-page/search-page.component";
import { ListComponent } from "./list/list.component";
import { VideoSeriesComponent } from "./video-series/video-series.component";
import { VideoProviderComponent } from "./video-provider/video-provider.component";
import { FavoriteListComponent } from "./favorite-list/favorite-list.component";
import { GenereComponent } from "./genere/genere.component";
import { GenereListComponent } from "./genere-list/genere-list.component";
import { LanguageComponent } from "./language/language.component";
import { LanguageListComponent } from "./language-list/language-list.component";
import { PaymentComponent } from "./payment/payment.component";
import { RecommendedListComponent } from "./recommended-list/recommended-list.component";
import { CastCrewListComponent } from "./cast-crew-list/cast-crew-list.component";
import { AudioDetailComponent } from "./audio-detail/audio-detail.component";
import { DocumentDetailComponent } from "./document-detail/document-detail.component";
import { CategoryComponent } from "./category/category.component";
import { MoviesComponent } from "./movies/movies.component";
import { TvShowsComponent } from "./tv-shows/tv-shows.component";
import { PartnerContentDetailComponent } from "./partner-content-detail/partner-content-detail.component";
import { PartnerListComponent } from "./partner-list/partner-list.component";
import { MusicComponent } from "./music/music.component";
import { LiveComponent } from "./live/live.component";
import { MusicPlayerComponent } from "./music-player/music-player.component";
import { EpgProviderComponent } from "./epg-provider/epg-provider.component";
import { MusicListComponent } from "./music-list/music-list.component";
import { LiveStreamingComponent } from "./live-streaming/live-streaming.component";
import { ActivationComponent } from "./activation/activation.component";
import { AuthGuardService } from "../guard/auth-guard.service";
import { PoadcastComponent } from './poadcast/poadcast.component';
import { SongDetailComponent } from "./song-detail/song-detail.component";

const routes: Routes = [
  {
    path: "",
    component: BaseComponent,
    children: [
      {
        path: "",
        component: HomeComponent,
      },
      {
        path: "video-detail/:public_id",
        component: VideoDetailComponent,
      },
      {
        path: "document-detail/:public_id",
        component: DocumentDetailComponent,
      },
      {
        path: "audio-detail/:public_id",
        component: AudioDetailComponent,
      },
      {
        path: "series/:public_id",
        component: VideoSeriesComponent,
      },

      {
        path: "results",
        component: SearchPageComponent,
      },
      {
        path: "list/:list",
        component: ListComponent,
      },
      {
        path: "partner-detail/:id",
        component: PartnerContentDetailComponent,
      },
      {
        path: "partner-list",
        component: PartnerListComponent,
      },
      {
        path: "provider/:slug/:public_id",
        component: VideoProviderComponent,
      },
      {
        path: "favorite",
        component: FavoriteListComponent,
      },
      {
        path: "cast-crew",
        component: CastCrewListComponent,
      },
      {
        path: "genere/:slug",
        component: GenereComponent,
        data: { url: "results" },
      },
      {
        path: "genere-list/:slug/:subslug",
        component: GenereListComponent,
        data: { url: "results" },
      },
      {
        path: "language/:slug",
        component: LanguageComponent,
        data: { url: "results" },
      },
      {
        path: "language-list/:slug",
        component: LanguageListComponent,
        data: { url: "results" },
      },
      {
        path: "language-list/:slug/:subslug",
        component: LanguageListComponent,
        data: { url: "results" },
      },
      {
        path: "recommended-list",
        component: RecommendedListComponent,
        // data : {url : 'results'}
      },

      {
        path: "payment/:slug/:type/:public_id",
        component: PaymentComponent,
        data: { url: "results" },
      },
      {
        path: "category",
        component: CategoryComponent,
      },
      {
        path: "category/:slug",
        component: CategoryComponent,
      },
      {
        path: "list/:popular-trending-series",
        component: ListComponent,
      },
      {
        path: "list/:top-rated-contents",
        component: ListComponent,
      },
      {
        path: "list/:popular-trending-contents",
        component: ListComponent,
      },
      {
        path: "movies",
        component: MoviesComponent,
      },
      {
        path: "shows",
        component: TvShowsComponent,
      },
      {
        path: "live",
        component: LiveComponent,
      },
      {
        path: "live-streaming/:id",
        component: LiveStreamingComponent,
      },
      {
        path: "music-player/:id",
        component: MusicPlayerComponent,
      },
      {
        path: "epg-provider",
        component: EpgProviderComponent,
      },
      {
        path: "music",
        component: MusicComponent,
      },
      {
        path: "music/:slug",
        component: MusicComponent,
      },
      {
        path: "music-list/:slug",
        component: MusicListComponent,
      },
      {
        path: "podcast-list/:slug",
        component: MusicListComponent,
      },
      {
        path: "activation",
        component: ActivationComponent,
      },
      {
        path: "podcast",
        component: PoadcastComponent,
      },
      {
        path: "song-detail/:id",
        component: SongDetailComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule { }
